import { createClient } from '@supabase/supabase-js';
import { getOrCreateSessionToken } from './sessionToken';

// Initialize the session token at module-load time so every supabase.from(...) and
// supabase.rpc(...) carries the X-Session-Token header. Spec: WIRING §2.4.2.
const sessionToken = getOrCreateSessionToken();

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    global: { headers: { 'X-Session-Token': sessionToken } },
  }
);
